/* v8 ignore start */
/**
 * @public
 */
// extracted into a separate file to avoid circular dependencies
export enum LottieLayerType {
  PreComposition = 0,
  SolidColor = 1,
  Image = 2,
  Null = 3,
  Shape = 4,
  Text = 5,
  Audio = 6,
  VideoPlaceholder = 7,
  ImageSequence = 8,
  Video = 9,
  ImagePlaceholder = 10,
  Guide = 11,
  Adjustment = 12,
  Camera = 13,
  Light = 14,
  Data = 15,
}
/* v8 ignore stop */
